module.exports = __webpack_public_path__ + "img/DE00715.dfa714dc.png";